<template>
  <div class="innerBox" style="position: absolute;overflow-y:auto;overflow-x: auto !important;">
    <el-row style="width: 100%;height: 4%;background-color: #FFFFFF;text-align: left;line-height: 230%">
      <div class="homeImage"></div>
      首页
    </el-row>
    <el-row style="width: 100%;height: 95%;padding: 20px 20px 5px 20px;">
      <el-row style="height: 65%">
        <el-col :span="17" style="height: 98%">
          <el-row style="height: 25%;margin-left: -5px">
            <el-col :span="6" style="height: 100%;">
              <div class="minCard minCard1" >
                <div class="preview">
                  <span>
                    当月未完成
                  </span>
                  <span class="numberClass">
                    {{ statisticsData.noCompleteNum }}
                  </span>
                </div>
              </div>
            </el-col>

            <el-col :span="6" style="height: 100%;">
              <div class="minCard minCard2" >
                <div class="preview">
                  <span>
                    当月已完成
                  </span>
                  <span class="numberClass">
                    {{ statisticsData.monthCompleteNum }}
                  </span>
                </div>
              </div>
            </el-col>

            <el-col :span="6" style="height: 100%;">
              <div class="minCard minCard3" >
                <div class="preview">
                  <span>
                    当年已完成
                  </span>
                  <span class="numberClass">
                    {{ statisticsData.yearCompleteNum }}
                  </span>
                </div>
              </div>
            </el-col>

            <el-col :span="6" style="height: 100%;">
              <div class="minCard minCard4" >
                <div class="preview">
                  <span>
                    累计已完成
                  </span>
                  <span class="numberClass">
                    {{ statisticsData.totalCompleteNum }}
                  </span>
                </div>
              </div>
            </el-col>

          </el-row>
          <el-row style="height: 75%;width: 99.5%">
            <el-card class="card_style" body-style="height:90%" style="height: 94%;padding-left: 5px;margin-top: 10px" >
              <div style="text-align: left;margin-bottom: 8px;margin-top: -8px;flex-shrink: 0;">
                <div class="ver_line"></div>
                <span style="color: #4482FE">&nbsp;工单完成情况</span>
              </div>

              <el-row style="margin-bottom: 0;flex: auto;height: 100%">
                <el-col :span="10" style="height: 100%;">
                  <el-date-picker
                    size="mini"
                    style="float: right;width: 90px;z-index: 1"
                    v-model="year"
                    type="year"
                    format="yyyy"
                    value-format="yyyy"
                    placeholder="年份"
                    @change="yearChange">
                  </el-date-picker>
                  <div id="workOrderCompleteLineChart" style="width: 100%;height: 100%" v-loading="workOrderCompleteLoading" :element-loading-text="'全力加载中'"></div>
                </el-col>
                <el-col :span="13" :offset="1" style="height: 100%">
                  <el-row style="height: 100%">
                    <el-col :span="6" style="height: 100%;">
                      <div style="height: 70%;margin-top: 25%;padding: 15% 5px 5% 5px;background: linear-gradient(to right,#6196FE, #3F7FFE);border-radius: 5px;overflow-y: auto">
                        <div v-for="(item, id) in projectList" :key="id" style="height: 20%;">
                          <!-- 实现盒子单个改变不同色 -->
                          <div :class="['composeDiv',composeRoadActive===id?'composeChooseDiv':'composeDiv']" @click="composeRoadChange(item,id)">
                            <label style="cursor: pointer;">
                              {{item.name}}
                            </label>
                          </div>
                        </div>
                      </div>
                    </el-col>
                    <el-col :span="18" style="height: 100%">
                      <div id="workOrderGroupLineChart" style="width: 100%;height: 100%" v-loading="workOrderGroupLoading" :element-loading-text="'全力加载中'"></div>
                    </el-col>
                  </el-row>
                </el-col>
              </el-row>
            </el-card>
          </el-row>
        </el-col>
        <el-col :span="7" style="height: 100%">
          <el-card class="card_style" body-style="height:90%;" style="height: 95.1%;width: 96%;padding-left: 5px;margin-top: 0.5%;margin-left: 1.7%" >
            <div style="text-align: left;margin-bottom: 10px;margin-top: -8px;flex-shrink: 0;">
              <div class="ver_line"></div>
              <span style="color: #4482FE">&nbsp;工单最新进展</span>
            </div>
            <div style="height: 100%">
              <div style="height: 32%;border-top: 2px solid #F4F4F4">
                <div style="text-align: left;flex-shrink: 0;line-height: 30%;">
                    <span style="color: #4482FE;line-height: 30px">&nbsp;&nbsp;&nbsp;○</span>
                    <span style="font-size: 15px;line-height: 30px;font-weight: bold">巡检</span>
                  <label class="grid-link"  @click="jumpToInspection">查看全部 ></label>
                </div>
                <div style="height: 70%;width: 100%;float:left;font-size: 13px" >
                  <el-row style="height: 40%;width:100%;background-color: #FAFAFA;line-height: 300%">
                    <template v-if="inspectionList[0]">
                      <el-col :span="11" :offset="1" class="nameClass" :title="inspectionList[0].workOrderName">{{inspectionList[0].workOrderName | wordCut}}</el-col>
                      <el-col :span="3" :class="'statusColor'+ inspectionList[0].status">{{inspectionList[0].statusName}}</el-col>
                      <el-col :span="7" :offset="1">{{inspectionList[0].showTime}}</el-col>
                    </template>
                    <template v-else>
                    </template>
                  </el-row>
                  <el-row style="height: 40%;width:100%;background-color: #EAF2F8;line-height: 300%">
                    <template v-if="inspectionList[1]">
                      <el-col :span="11" :offset="1" class="nameClass" :title="inspectionList[1].workOrderName">{{inspectionList[1].workOrderName | wordCut}}</el-col>
                      <el-col :span="3" :class="'statusColor'+ inspectionList[1].status">{{inspectionList[1].statusName}}</el-col>
                      <el-col :span="7" :offset="1">{{inspectionList[1].showTime}}</el-col>
                    </template>
                    <template v-else>
                    </template>
                  </el-row>
                </div>
              </div>
              <div style="height: 32%;border-top: 2px solid #F4F4F4">
                <div style="text-align: left;flex-shrink: 0;line-height: 30%;">
                    <span style="color: #4482FE;line-height: 30px">&nbsp;&nbsp;&nbsp;○</span>
                  <span style="font-size: 15px;line-height: 30px;font-weight: bold">维修</span>
                  <label class="grid-link"  @click="jumpToDefect">查看全部 ></label>
                </div>
                <div style="height: 70%;width: 100%;float:left;font-size: 13px">
                  <el-row style="height: 40%;width:100%;background-color: #FAFAFA;line-height: 300%">
                    <template v-if="defectList[0]">
                      <el-col :span="11" :offset="1" class="nameClass" :title="defectList[0].workOrderName">{{defectList[0].workOrderName | wordCut}}</el-col>
                      <el-col :span="3" :class="'statusColor'+ defectList[0].status">{{defectList[0].statusName}}</el-col>
                      <el-col :span="7" :offset="1">{{defectList[0].showTime}}</el-col>
                    </template>
                    <template v-else>
                    </template>
                  </el-row>
                  <el-row style="height: 40%;width:100%;background-color: #EAF2F8;line-height: 300%">
                    <template v-if="defectList[1]" >
                      <el-col :span="11" :offset="1" class="nameClass" :title="defectList[1].workOrderName">{{defectList[1].workOrderName | wordCut}}</el-col>
                      <el-col :span="3" :class="'statusColor'+ defectList[1].status">{{defectList[1].statusName}}</el-col>
                      <el-col :span="7" :offset="1">{{defectList[1].showTime}}</el-col>
                    </template>
                    <template v-else>
                    </template>
                  </el-row>
                </div>
              </div>
              <div style="height: 32%;border-top: 2px solid #F4F4F4">
                <div style="text-align: left;flex-shrink: 0;line-height: 30%;">
                    <span style="color: #4482FE;line-height: 30px">&nbsp;&nbsp;&nbsp;○</span>
                  <span style="font-size: 15px;line-height: 30px;font-weight: bold">抢修</span>
                  <label class="grid-link"  @click="jumpToRepair">查看全部 ></label>
                </div>
                <div style="height: 70%;width: 100%;float:left;font-size: 13px">
                  <el-row style="height: 40%;width:100%;background-color: #FAFAFA;line-height: 300%">
                    <template v-if="repairList[0]">
                      <el-col :span="11" :offset="1" class="nameClass" :title="repairList[0].workOrderName">{{repairList[0].workOrderName | wordCut}}</el-col>
                      <el-col :span="3" :class="'statusColor'+ repairList[0].status">{{repairList[0].statusName}}</el-col>
                      <el-col :span="7" :offset="1">{{repairList[0].showTime}}</el-col>
                    </template>
                    <template v-else>
                    </template>
                  </el-row>
                  <el-row style="height: 40%;width:100%;background-color: #EAF2F8;line-height: 300%">
                    <template v-if="repairList[1]">
                      <el-col :span="11" :offset="1" class="nameClass" :title="repairList[1].workOrderName">{{repairList[1].workOrderName | wordCut}}</el-col>
                      <el-col :span="3" :class="'statusColor'+ repairList[1].status">{{repairList[1].statusName}}</el-col>
                      <el-col :span="7" :offset="1">{{repairList[1].showTime}}</el-col>
                    </template>
                    <template v-else>
                    </template>
                  </el-row>
                </div>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <el-row style="height: 35%;margin: 6px auto">
        <el-col :span="3" style="height: 100%">
          <div style="height: 100%;background: linear-gradient(to right,#6196FE, #3F7FFE);margin-top: -15px;border-radius: 5px 0 0 5px;overflow-y: auto">
            <div style="height: 8%"></div>
            <div v-for="(item, id) in projectList" :key="id" style="height: 18%;">
              <!-- 实现盒子单个改变不同色 -->
              <div :class="['roadDiv',bottomRoadActive===id?'roadChooseDiv':'roadDiv']" @click="roadChange(item,id)">
                <label style="cursor: pointer;">
                  {{item.name}}
                </label>
              </div>
            </div>
          </div>
        </el-col>
        <el-col :span="6" style="height: 100%;margin-top: -15px;background: linear-gradient(to right,#D8E1F4, #FFFFFF 60%);" v-loading="workOrderFeeLoading" :element-loading-text="'全力加载中'">
          <div style="height: 12%;">
            <div style="height: 30%">
            </div>
            <el-row>
              <el-col :span="3" :offset="1">
                <el-date-picker
                  size="mini"
                  style="width: 90px"
                  v-model="bottomYear"
                  type="year"
                  format="yyyy"
                  value-format="yyyy"
                  placeholder="年份"
                  @change="bottomYearChange">
                </el-date-picker>
              </el-col>
              <el-col :span="3" :offset="3">
                <el-date-picker
                  size="mini"
                  style="width: 90px"
                  popper-class="monthStyle"
                  v-model="bottomMonth"
                  type="month"
                  format="MM"
                  value-format="MM"
                  placeholder="月份"
                  :disabled="(this.bottomYear === '' || this.bottomYear === null)"
                  @change="bottomMonthChange">
                </el-date-picker>
              </el-col>
            </el-row>

            </div>
          <div id="workOrderTypePieChart" style="width: 100%;height: 82%;"></div>
        </el-col>
        <el-col :span="8" style="height: 100%;margin-top: -15px;background: white;"  v-loading="workOrderFeeLoading" :element-loading-text="'全力加载中'">
          <div style="height: 12%"></div>
          <div>
            <span style="font-size: 18px;font-weight: bolder;font-family:sans-serif">养护单位执行占比</span>
          </div>
          <div style="height: 4%"></div>

          <div style="width: 85%;height: 72%;margin:0 auto;overflow-y: auto">
            <div v-if="unitDataList === null || unitDataList.length === 0" class="txt-center">暂无数据</div>
            <div v-else v-for="(item, id) in unitDataList" style="width: 90%" :key="id">
              <div style="width: 100%;font-size: 16px;text-align: left;">
                {{item.name}}
              </div>
              <div style="height: 23px;margin-top: 22px;position: relative" >
                <div :style="item.box" >
<!--                  尺子底图-->
                  <div class="backRuler">
                    <span>0</span>
                    <span>10</span>
                    <span>20</span>
                    <span>30</span>
                    <span>40</span>
                    <span>50</span>
                    <span>60</span>
                    <span>70</span>
                    <span>80</span>
                    <span>90</span>
                  </div>
                  <div :style="item.box1"></div>
                  <div :style="item.box2"></div>
                  <div :style="item.box3"></div>

                </div>
                <div class="percentLineClass" :style="{left:item.orderPercent + '%'}">
                </div>
                <div class="perCentClass" :style="{left:((item.orderPercent > 5 && /[\.]/.test(item.orderPercent)) ? item.orderPercent - 4 : item.orderPercent -2)  + '%'}">
                  {{item.orderPercent}}%
                </div>
              </div>
              <div>
                <div class="legendClass">
                  <div class="inspection"></div>
                  巡检&nbsp;{{item.box1.percentage}}
                </div>
                <div class="legendClass">
                  <div class="defect"></div>
                  维修&nbsp;{{item.box2.percentage}}
                </div>
                <div class="legendClass">
                  <div class="repair"></div>
                  抢修&nbsp;{{item.box3.percentage}}
                </div>
              </div>

            </div>
          </div>
        </el-col>
        <el-col :span="7" style="height: 100%;margin-top: -15px;background: linear-gradient(to left,#D8E1F4, #FFFFFF 50%);" v-loading="workOrderFeeLoading" :element-loading-text="'全力加载中'">
          <div id="repairExpensesLineChart" style="width: 100%;height: 88%;margin-top:7%"></div>
        </el-col>
      </el-row>
    </el-row>
  </div>
</template>

<script>
  import {cutString} from "../../../utils/tool";

  let myApp;
  import pageHeader from "../Common/PageHeader";
  import echarts from "echarts";
  export default {
    name: "BizHome",
    components: {
      pageHeader,
    },
    data() {
      return {
        workOrderCompleteLoading: false,
        workOrderGroupLoading: false,
        workOrderFeeLoading: false,
        year: '',
        bottomYear: '',
        bottomMonth: '',
        statisticsData:{
          'noCompleteNum': '0',
          'momCompleteNum': 0,
          'yearUnFinish': 0,
          'totalCompleteNum': 0,
        },
        inspectionList:[],
        defectList:[],
        repairList:[],
        projectList: [
          { id: 0,name:'全部', projectId: '' },
        ],
        composeRoadActive: 0,
        composeRoadProject: '',
        bottomRoadActive: 0,
        bottomRoadProject: '',
        unitDataList: [],
      }
    },
    filters:{
      wordCut:function (value){
        return cutString(value,18);
      },
    },
    computed: {
    },
    methods: {
      jumpToInspection() {
        this.$router.push('/biz/workorder/woInspection/list')
      },
      jumpToDefect() {
        this.$router.push('/biz/workorder/woDefect/list')
      },
      jumpToRepair() {
        this.$router.push('/biz/workorder/woRepair/list')
      },
      composeRoadChange (item, id) {
        this.composeRoadActive = id
        this.composeRoadProject = item.projectId;
        this.getOrderGroupData();
      },
      roadChange (item, id) {
        this.bottomRoadActive = id
        this.bottomRoadProject = item.projectId;
        this.getOrderFeeData();
      },
      yearChange() {
        this.month = '';
        this.getOrderCompleteData();
        this.getOrderGroupData();
      },
      bottomYearChange() {
        this.bottomMonth = '';
        this.getOrderFeeData();
      },
      bottomMonthChange() {
        this.getOrderFeeData();
      },
      //统计数据、工单最新进度
      getWaitTasks: function () {
        this.$api.homeData.getWaitTasks().then((res) => {
          this.statisticsData.noCompleteNum = res.data.noCompleteNum;
          this.statisticsData.monthCompleteNum = res.data.monthCompleteNum;
          this.statisticsData.yearCompleteNum = res.data.yearCompleteNum;
          this.statisticsData.totalCompleteNum = res.data.totalCompleteNum;
          this.inspectionList = res.data.inspectionList;
          this.defectList = res.data.defectList;
          this.repairList = res.data.repairList;
        })
      },
      //工单整体分布图
      getOrderCompleteData: function () {
        this.workOrderCompleteLoading = true;
        this.$api.homeData.getOrderCompleteData({year: this.year}).then((res) => {
          this.setChartData("workOrderCompleteLineChart",res.data);
          this.workOrderCompleteLoading = false;
        })
      },
      //工单构成情况分分析图
      getOrderGroupData: function () {
        myApp.workOrderGroupLoading = true;
        myApp.$api.homeData.getOrderGroupData({year: this.year,month: this.month,projectId: this.composeRoadProject}).then((res) => {
          if (res.code === 200){
            myApp.setChartData("workOrderGroupLineChart",res.data);
            myApp.workOrderGroupLoading = false;
          }
        })
      },
      //首页下部数据
      getOrderFeeData: function () {
        this.workOrderFeeLoading = true;
        this.$api.homeData.getOrderFeeData({year: this.bottomYear,month: this.bottomMonth,projectId: this.bottomRoadProject}).then((res) => {
          this.setUnitDataList(res.data.unitData);
          this.setChartData('workOrderTypePieChart',res.data.typeData);
          this.setChartData('repairExpensesLineChart',res.data.repairData);
        })
      },
      //处理养护单位执行占比数据
      setUnitDataList: function (data){
        this.unitDataList = [];
        for (let i = 0; i < data.length; i++) {
          let array = data[i];
          let unitData = {
            name:'',
            orderPercent:'',
            box: {
              width: '100%',
              height: '23px',
              display: 'flex',
              background: '#D6D6D6',
              borderRadius : '10px',
              overflowX: 'hidden'
            },
            box1:{
              width: '0%',
              percentage: '',
              background: 'linear-gradient(to right,#0FF36B, #02CF81 100%)',
            },
            box2:{
              width: '0%',
              percentage: '',
              background: 'linear-gradient(to right,#1187E9, #1B60ED 100%)',
            },
            box3:{
              width: '0%',
              percentage: '',
              background: 'linear-gradient(to right,#F0CD68, #EEA700 100%)',
            },
          };
          unitData.name = array.deptName;
          unitData.orderPercent = array.orderPercent;
          let num = array.defectNum + array.inspectionNum + array.repairNum;
          unitData.box1.width =  (array.orderPercent * array.inspectionNum/num).toFixed(2) + "%";
          unitData.box1.percentage =  (array.inspectionNum/num*100).toFixed(2) + "%";
          unitData.box2.width =  (array.orderPercent * array.defectNum/num).toFixed(2) + "%";
          unitData.box2.percentage =  (array.defectNum/num*100).toFixed(2) + "%";
          unitData.box3.width =  (array.orderPercent * array.repairNum/num).toFixed(2) + "%";
          unitData.box3.percentage =  (array.repairNum/num*100).toFixed(2) + "%";
          this.unitDataList.push(unitData);
        }
        this.workOrderFeeLoading = false;
      },
      //调用对应的echarts图
      setChartData:function (id, data) {
        let divId = id;
        let chartData = data;
        let title = chartData.title;
        let categoryNames = chartData.categoryNames;
        let seriesNames = chartData.seriesNames;
        let values = chartData.values;
        let unit = chartData.unit;
        let chart = this.$echarts.init(document.getElementById(divId));
        let methodName = 'show' + id.slice(0,1).toUpperCase() +id.slice(1,id.length);
        let methods = this.$options.methods;
        methods[methodName](title, chart, categoryNames, seriesNames, values, unit);
      },
      //工单整体分布图
      showWorkOrderCompleteLineChart: function (title, chart, categoryNames, seriesNames, values, unit) {
        let orderNum = values[0];
        let completeNum = values[1];

        let option = {
          title: [
            {
              left: 'center',
              text: title,
            },
          ],
          tooltip: {
            trigger: "axis",
            formatter: '{b}月<br/>总工单数&nbsp;{c}' + unit + '<br/>已完成工单数&nbsp;{c1}' +unit,
            textStyle:{
              color: '#676767',
              fontSize: 14,
              // fontWeight: 'bold',
            },
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            borderColor: '#4CA29B',
            borderWidth: '1',
            borderRadius: 10,
          },
          legend: {
            left: 'center',
            top: '10%',
            data: ['已完成工单数',"总工单数"]
          },
          grid: {
            left: '10%',
            right: '5%',
            top: '30%',
            bottom: '15%',
            // containLabel: true
          },
          dataZoom: {
            type: 'inside'
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            data: categoryNames,
            axisLabel: {
              show: true,
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
          },

          yAxis: {
            name: '',
            type: 'value',
            axisLabel: {
              show: true,
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#ccc',
                type: 'dashed',
              }
            },
            minInterval: 1,
          },
          series: [
            {
              name: '总工单数',
              type: 'line',
              symbol: "circle",
              symbolSize:5,
              data: orderNum,
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 0,
                    color: '#C3D6F2'
                  },

                ])
              },
              markPoint: {
                symbol: 'roundRect',
                symbolOffset: [0, -15],
                itemStyle: {
                  color: "rgba(255, 0, 0, 0)"
                },
                label: {
                  color: "rgba(255, 255, 255, 1)"
                },
              },
              itemStyle: {
                normal: {
                  color: 'rgba(0,157,255, 1)', //改变折线点的颜色
                  lineStyle: {
                    color: 'rgba(0,157,255, 1)' //改变折线颜色
                  }
                }
              },
            },
            {
              name: '已完成工单数',
              type: 'line',
              stack: 'Total',
              symbol: "circle",
              symbolSize:5,
              data: completeNum,
              areaStyle: {
                color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                  {
                    offset: 1,
                    color: '#4CA29B'
                  },
                ])
              },

              itemStyle: {
                normal: {
                  color: '#4CA29B', //改变折线点的颜色
                  lineStyle: {
                    color: '#4CA29B' //改变折线颜色
                  }
                }
              },
            },
          ],
        };
        chart.setOption(option);
        let that = this;
        chart.getZr().on('click', params => {
          const pointInPixel = [params.offsetX, params.offsetY]
          if (chart.containPixel('grid', pointInPixel)) {
            const xIndex = chart.convertFromPixel({ seriesIndex: 0 }, [params.offsetX, params.offsetY])[0];
            that.month = option.xAxis.data[xIndex];
            that.getOrderGroupData();
          }
        })
      },
      //工单构成情况分布图
      showWorkOrderGroupLineChart: function (title, chart, categoryNames, seriesNames, values, unit) {
        let orderNum = values[0];
        let completeNum = values[1];

        let option = {
          title: [
            {
              left: 'center',
              text: title,
            },
          ],
          tooltip: {
            trigger: "axis",
            formatter: '{b}<br/>总工单数&nbsp;{c}' + unit + '<br/>已完成工单数&nbsp;{c1}' +unit,
            textStyle:{
              color: '#676767',
              fontSize: 14,
              // fontWeight: 'bold',
            },
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            borderColor: '#4CA29B',
            borderWidth: '1',
            borderRadius: 10,
          },
          legend: {
            left: 'center',
            top: '10%',
            data: ['总工单数',"已完成工单数"]
          },
          grid: {
            left: '10%',
            right: '5%',
            top: '30%',
            bottom: '15%',
            // containLabel: true
          },
          dataZoom: {
            type: 'inside'
          },
          xAxis: {
            type: 'category',
            data: categoryNames,
            axisLabel: {
              fontSize: 15,
              show: true,
            },
            axisLine: {
              show: true,
            },
            axisTick: {
              show: false,
            },
          },
          yAxis: {
            name: '',
            type: 'value',
            axisLabel: {
              show: true,
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#ccc',
                type: 'dashed',
              }
            },
          },
          series: [
            {
              name: '总工单数',
              data: orderNum,
              type: 'bar',
              showBackground: true,
              backgroundStyle: {
                color: 'rgba(0,0,0,0)',
              },
              itemStyle: {
                normal: {
                  color: 'rgb(0,157,255)',
                  lineStyle: {
                    color: 'rgba(0,157,255, 1)',
                  }
                }
              },
            },
            {
              name: '已完成工单数',
              data: completeNum,
              type: 'bar',
              showBackground: true,
              backgroundStyle: {
                color: 'rgba(0,0,0,0)',
              },
              itemStyle: {
                normal: {
                  color: '#00BC8A',
                  lineStyle: {
                    color: '#00BC8A',
                  }
                }
              },
            },
          ],
        };

        chart.setOption(option);
      },
      //工单类型占比
      showWorkOrderTypePieChart: function(title, chart, categoryNames, seriesNames, values, unit) {
        let datas =[];
        for (let i = 0; i < values[0].length; i++) {
          let serierData = {value: values[0][i], name: categoryNames[i]};
          datas.push(serierData);
        }
        let option = {
          title: {
            left: 'center',
            text: '工单类型占比',
            x: 'left',
            y: 'top',
          },
          //距离边框位置
          grid: {
            left: '10%',
            right: '5%',
            top: '10%',
            bottom: '15%',
          },
          color:['#1ABB9C','#8E7BFC','#528CFE'],
          legend: {
            bottom: "-3%",
            data:categoryNames
          },
          series: [
            {
              name: title,
              data: datas,
              type: 'pie',
              radius: ['40%', '70%'],
              // showBackground: true,
              label: {
                formatter: '{b}{c}',
                minMargin: 10,
                edgeDistance: 10,
                lineHeight: 18,
                fontSize: 12,
                rich: {
                  time: {
                  }
                }
              },
            }
          ]
        };
        chart.setOption(option);
      },
      //抢修工单费用分析
      showRepairExpensesLineChart: function (title, chart, categoryNames, seriesNames, values, unit) {
        let num = values[0][0] + values[0][1] +  values[0][2];
        let datas = [
          {
            value: values[0][0],
            itemStyle: {
              color: '#528CFE'
            }
          },{
            value: values[0][1],
            itemStyle: {
              color: '#1ABB9C'
            }
          },
          {
            value: values[0][2],
            itemStyle: {
              color: '#8E7BFC'
            }
          },
        ]
        let option = {
          title: [
            {
              left: 'center',
              text: title,
            },
            {
              right: '50',
              text: '总计(元)：' + num,
              textStyle: {
                fontWeight: "normal",
                fontSize : 12,
                lineHeight: '30',
              }
            }
          ],
          tooltip: {
            trigger: "axis",
            formatter: '{b}<br/>费用&nbsp;{c}' + unit,
            textStyle:{
              color: '#676767',
              fontSize: 14,
              // fontWeight: 'bold',
            },
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
            borderColor: '#4CA29B',
            borderWidth: '1',
            borderRadius: 10,
          },
          grid: {
            left: '10%',
            right: '5%',
            top: '20%',
            bottom: '15%',
          },
          // dataZoom: {
          //   type: 'inside'
          // },
          xAxis: {
            type: 'category',
            data: categoryNames,
            axisLabel: {
              fontSize: 15,
              show: true,
            },
            axisLine: {
              show: true,
            },
            axisTick: {
              show: false,
            },
          },
          yAxis: {
            name: '',
            type: 'value',
            axisLabel: {
              show: true,
            },
            axisLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            splitLine: {
              show: true,
              lineStyle: {
                color: '#ccc',
                type: 'dashed',
              }
            },
          },
          series: [
            {
              name: '',
              data: datas,
              type: 'bar',
              showBackground: true,
              backgroundStyle: {
                color: 'rgba(0,0,0,0)',
              },
              barWidth: '20%',
              itemStyle: {
                normal: {
                  color: 'rgb(0,157,255)',
                  lineStyle: {
                    color: 'rgba(0,157,255, 1)',
                  }
                }
              },
            },
          ]
        };
        chart.setOption(option);
      },
      //获取路段列表
      getProjectList(){
        this.$api.project.list().then((res) => {
          let list = res.data.list;
          for (let i = 0; i < list.length; i++) {
            let oneProject = { id: 0,name:'', projectId: '' };
            oneProject.id = i+1;
            oneProject.name = list[i].name;
            oneProject.projectId = list[i].id;
            this.projectList.push(oneProject);
          }
        })
      },
    },
    mounted() {
      myApp = this;
      this.getWaitTasks();
      this.getOrderCompleteData();
      this.getOrderGroupData();
      this.getOrderFeeData();
      this.getProjectList();
    }
  }
</script>

<style scoped>

.homeImage {
  width: 22px;
  height: 19px;
  float: left;
  margin-top: 7px;
  margin-left: 10px;
  background: url("/static/img/table/navigate.png") no-repeat;
}

.minCard{
  height: 100%;
  width: 100%;
  margin: 0 auto;
  border-radius: 5px;
}

.minCard1{
  background:url("/static/img/home/base_blue.png") no-repeat;
  background-size: 100% 100%;
}
.minCard2{
  background:url("/static/img/home/base_green.png") no-repeat;
  background-size: 100% 100%;
}
.minCard3{
  background:url("/static/img/home/base_orange.png") no-repeat;
  background-size: 100% 100%;
}
.minCard4{
  background:url("/static/img/home/base_purple.png") no-repeat;
  background-size: 100% 100%;
}

.preview {
  padding-top: 30px;
  padding-left: 40px;
  width: 100px;
  font-size: 16px;
  color: whitesmoke;
  line-height: 16px;
}
.numberClass{
  margin-top: 10px;
  margin-left: 10px;
  font-size: 40px;
  line-height: 40px;
  text-align: left;
  float: left;
}

.ver_line {
  width: 5px;
  height: 16px;
  margin-top: 3px;
  float: left;
  background: url("/static/img/home/title_bg_repeat.png");
}

.composeDiv {
  color: white;
  line-height: 40px;
  cursor: pointer;
}
.chooseDiv {
  background-color: #D2E5FF;
  color: #409eff;
  border-radius: 10px;
  cursor: pointer;
}
.composeChooseDiv {
  background-color: #D2E5FF;
  color: #409eff;
  border-radius: 10px;
  cursor: pointer;
}

.roadDiv {
  width: 70%;
  margin-left: 15%;
  color: white;
  line-height: 40px;
  cursor: pointer;
}
.roadChooseDiv {
  background-color: #D2E5FF;
  color: #4684FE;
  border-radius: 10px;
  cursor: pointer;
}

.nameClass{
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.percentLineClass{
  background-color: #70BACA;
  position: absolute;
  width: 3px;
  height: 150%;
  top: -40%;
  left: -2px;
}

.perCentClass{
  border-radius: 5px;
  background-color: #70BACA;
  color: white;
  position: absolute;
  top: -22px;
  font-size: 12px;
  padding: 2px
}

.legendClass{
  font-size: 12px;
  margin-top: 6px;
  padding-left: 10%;
  float: left;
  width: 23%;
  height: 25px;
}

.inspection{
  margin-top: 2px;
  width: 13px;
  height: 13px;
  background-color: #12F16D;
  float: left;
}
.defect{
  margin-top: 2px;
  width: 13px;
  height: 13px;
  background-color: #127BF2;
  float: left;
}
.repair{
  margin-top: 2px;
  width: 13px;
  height: 13px;
  background-color: #F0BD35;
  float: left;
}

.grid-link {
  text-decoration: none;
  color: #409eff;
  cursor: pointer;
  float: right;
  margin: 3% 4% 4% 3%;
  font-size: 12px;
}

.grid-link:hover {
  color: #f56c6c;
}

.txt-center {
  text-align: center;
  text-align: -webkit-center;
}
</style>



// WEBPACK FOOTER //
// src/views/Biz/Home/Main.vue